var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconList24Line(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4998 6.44922H9.7998V8.14917H18.4998V6.44922Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4998 11.1504H9.7998V12.8504H18.4998V11.1504Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4998 15.8496H9.7998V17.5496H18.4998V15.8496Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.79903 8.59998C7.517 8.59998 8.09902 8.01796 8.09902 7.29999C8.09902 6.58202 7.517 6 6.79903 6C6.08106 6 5.49902 6.58202 5.49902 7.29999C5.49902 8.01796 6.08106 8.59998 6.79903 8.59998Z",
    fill: "current"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.79903 13.2992C7.517 13.2992 8.09902 12.7172 8.09902 11.9992C8.09902 11.2812 7.517 10.6992 6.79903 10.6992C6.08106 10.6992 5.49902 11.2812 5.49902 11.9992C5.49902 12.7172 6.08106 13.2992 6.79903 13.2992Z",
    fill: "current"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.79903 18.0004C7.517 18.0004 8.09902 17.4184 8.09902 16.7004C8.09902 15.9825 7.517 15.4004 6.79903 15.4004C6.08106 15.4004 5.49902 15.9825 5.49902 16.7004C5.49902 17.4184 6.08106 18.0004 6.79903 18.0004Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconList24Line);
export default __webpack_public_path__ + "static/media/icon_list_24_line.3cd14f5c0e5eef020db1a338bbf0a342.svg";
export { ForwardRef as ReactComponent };